import React, { createContext, ReactNode, useContext } from 'react';
import { AuthContextType } from './auth.types';
import { DataContextType, LayoutContextType } from './types';

type FabricContextType = {
  avContext: DataContextType &
    AuthContextType &
    Record<string, any> & {
      isLoading?: boolean;
    };
  layout: LayoutContextType;
};

const FabricContext = createContext<FabricContextType | undefined>(undefined);

type FabricProviderProps = {
  children: ReactNode;
  value: FabricContextType;
};

export function FabricProvider({ children, value }: FabricProviderProps) {
  return <FabricContext.Provider value={value}>{children}</FabricContext.Provider>;
}

export const useAvContext = () => {
  const context = useContext(FabricContext);
  if (context === undefined) {
    throw new Error('useAvContext must be used within a FabricUIProvider');
  }
  return context.avContext;
};

export const useLayoutContext = () => {
  const context = useContext(FabricContext);
  if (context === undefined) {
    throw new Error('useLayoutContext must be used within a FabricUIProvider');
  }
  return context.layout;
};
